/** 数据中心 → 萃茶机数据 → 多机互联工作（patch 162；自物料损耗 Tab 拆出） */
export const TEA_EARLY_BREW_WORK_MENU_IDS = {
  page: 990415,
  enName: 'teaEarlyBrewWork',
  parentEnName: 'dataOfTeaExtractorMachine'
}



// WEBPACK FOOTER //
// C:/Users/xiaolan/Desktop/Android/Xrross-SOC-Frontend/E:/xrross/Android/Xrross-SOC-Frontend/src/constants/teaEarlyBrewWork.js